module.exports = __webpack_public_path__ + "img/people-empty.4f2d1389.svg";